export default "__VITE_ASSET__640cce4b__"